<template lang="pug">
div.share-networks__wrapper
  ShareNetwork(
    v-for="network in networks"
    :network="network.network"
    :key="network.network"
    :style="{ backgroundColor: network.color }"
    :url="sharing.url"
    :title="title"
    :description="description"
    :media="promoImage"
    )
    img(:src="network.icon").share-networks__icon
</template>

<script>
import FacebookIcon from '~/assets/images/svg/icons/facebook_1.svg'
import VkIcon from '~/assets/images/svg/icons/vk.svg'
import TelegramIcon from '~/assets/images/svg/icons/telegram.svg'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    promoImage: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      article: {},
      tags: [],
      prev: null,
      next: null,
      sharing: {
        url: 'https://nekidaem.ru' + this.$route.fullPath
      },
      networks: [
        //{ network: 'facebook', icon: FacebookIcon },
        { network: 'vk', icon: VkIcon },
        { network: 'telegram', icon: TelegramIcon }
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.share-networks {
  &__wrapper {
    background-color: white;
    padding: 15px 15px 10px 0px;
    position: absolute;
  }

  &__wrapper>a {
    margin-right: 15px;
  }

  &__icon {
    width: 26px;
    height: 26px;
  }
}
</style>
